module.exports = __webpack_public_path__ + "assets/2296726655933682e16f5aea825effc4.png";